<i18n src="../../lib/i18n/product/locales.json"></i18n>
<template>
    <div class="terms">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <div class="terms_page max_width">
            <div class="terms_title">
                {{$t('terms_and_conditions')}}
            </div>
            <div class="terms_main" v-for="(item,index) in items">
                <h1 v-html="item.title">{{item.title}}</h1>
                <p v-html="item.content">{{item.content}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'

    export default {
        data () {
            return {
                isTransparent: false,
                items: [
                    {
                        title: this.$t('terms_and_conditions_title1'),
                        content: this.$t('terms_and_conditions_content1')
                    },
                    {
                        title: this.$t('terms_and_conditions_title2'),
                        content: this.$t('terms_and_conditions_content2')
                    },
                    {
                        title: this.$t('terms_and_conditions_title3'),
                        content: this.$t('terms_and_conditions_content3')
                    },
                    {
                        title: this.$t('terms_and_conditions_title4'),
                        content: this.$t('terms_and_conditions_content4')
                    },
                    {
                        title: this.$t('terms_and_conditions_title5'),
                        content: this.$t('terms_and_conditions_content5')
                    },
                    {
                        title: this.$t('terms_and_conditions_title6'),
                        content: this.$t('terms_and_conditions_content6')
                    },
                    {
                        title: this.$t('terms_and_conditions_title7'),
                        content: this.$t('terms_and_conditions_content7')
                    }
                ]
            }
        },
        components: {
            navbar
        }
    }
</script>

<style lang="scss">
    @import "../../scss/_term.scss";
</style>



// WEBPACK FOOTER //
// termsOfService.vue?75af831e